import { setCartItems } from 'dibs-buyer-layout/src/actions/cartActions.ts';
import { actionCreators } from 'dibs-buyer-layout/src/actions/index.ts';

const { setUserTypeTrade } = actionCreators;

export { setCartItems, setUserTypeTrade };
